import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const getUserProfile = async () => {
  const response = await api.get('/users/profile');
  return response.data;
};

export const changePassword = async ({ newPassword, confirmPassword }) => {
  const response = await api.post('/users/change-password', {
    newPassword,
    confirmPassword,
  });
  return response.data;
};